import { useRef } from "react";
import { message } from "antd";
import { Outlet } from "react-router-dom";
import { ExternalLinkHandler } from "@shared/ui";
import { Footer } from "./footer";
import { UserHeader } from "./header/header";
import { PrivateCheck } from "./private/private-check";
import "./user-layout.scss";

export const UserLayout = () => {
  const ref = useRef<HTMLDivElement>(null);

  const [, contextHolder] = message.useMessage();

  return (
    <PrivateCheck>
      <ExternalLinkHandler>
        <div className="user-layout">
          {contextHolder}
          <UserHeader />
          <main ref={ref} className="user-layout__main">
            <Outlet
              context={{
                wrapperRef: ref,
              }}
            />
          </main>
          <Footer />
        </div>
      </ExternalLinkHandler>
    </PrivateCheck>
  );
};
